// TODO(keep): Refactored file to keep
import apiClient from '@/lib/apiClient'
import { PaginationQueryParams } from '@/shared/schemas/pagination'

import { EligibleRoleDetailResponse, EligibleRoleResponse, EligibleRoleSearchResponse } from './types'

export const eligibleRoleApi = {
  getAll: async () => {
    const response = await apiClient.get<EligibleRoleResponse[]>('/eligible-roles')
    return response.data
  },
  getById: async (id: string, filters: PaginationQueryParams) => {
    const response = await apiClient.get<EligibleRoleDetailResponse>(`/eligible-roles/${id}`, {
      params: {
        ...filters,
      },
    })
    return response.data
  },
  searchByName: async (name: string) => {
    const response = await apiClient.get<EligibleRoleSearchResponse[]>('/eligible-roles/search-by-name', {
      params: { name },
    })
    return response.data
  },
}
